// extracted by mini-css-extract-plugin
export default {"Head":"Head_Head__S90Ff","Title":"Head_Title__o2gjZ"};